import Dialog, {
  DialogHeader,
  DialogHeading,
} from '@raydiant/raydial/components/Dialog';
import Modal from '@raydiant/raydial/components/Modal';
import Text from '@raydiant/raydial/components/Text';
import ProDeviceImg from './pro-device.svg';
import Button from '@raydiant/raydial/components/Button';

interface PurchaseProDeviceDialogProps {
  isOpen: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

const PurchaseProDeviceDialog = ({
  isOpen,
  onSubmit,
  onClose,
}: PurchaseProDeviceDialogProps) => {
  return (
    <Modal isOpen={isOpen} className="overflow-auto">
      <Dialog className="grid relative" showCloseButton onClose={onClose}>
        <DialogHeader>
          <DialogHeading>Want more screens? </DialogHeading>
        </DialogHeader>
        <div className="flex flex-col items-center px-4">
          <img
            src={ProDeviceImg}
            alt="pro device"
            className="w-[274px] aspect-[1.028] mb-8"
          />
          <Text className="text-center text-2xl md:text-3xl font-semibold">
            Looking to add another screen? Get a Displai Plan!
          </Text>

          <div className="flex flex-col gap-2 mt-6 md:mt-10">
            <Text>
              Each of your screen requires a Displai Plan. A Displai plan
              includes a Displai Player and a Displai License to run it.
            </Text>
            <Text>
              You can get an annual subscription discount if you subscribe now!
            </Text>
          </div>
        </div>
        <footer className="flex flex-wrap gap-6 pb-4 px-4 mt-8">
          <Button
            size="large"
            variant="primary"
            className="grow"
            onPress={onSubmit}
          >
            Get a plan now
          </Button>
        </footer>
      </Dialog>
    </Modal>
  );
};

export default PurchaseProDeviceDialog;
